const AUCTION_PRODUCT_PATTERN = /^\/collections\/all-auctions\/products\//;
const AUCTION_COLLECTION_PATTERN = /^\/collections\/all-auctions(\/|$)/;
const HOME_QUICK_VIEW_PATTERN = /^\/quick-view\//;
const SEARCH_QUICK_VIEW_PATTERN = /^\/search\/quick-view\//;

export const isEligibleBiddingSuggestionsPage = (pathname) => {
  if (pathname === "/") {
    return true;
  }

  if (HOME_QUICK_VIEW_PATTERN.test(pathname)) {
    return true;
  }

  if (
    pathname === "/search" ||
    SEARCH_QUICK_VIEW_PATTERN.test(pathname)
  ) {
    return true;
  }

  if (AUCTION_PRODUCT_PATTERN.test(pathname)) {
    return false;
  }

  if (AUCTION_COLLECTION_PATTERN.test(pathname)) {
    return true;
  }

  return false;
};

export const DISMISSED_AT_KEY = "BiddingSuggestions-dismissed-at";
export const OPT_OUT_KEY = "BiddingSuggestions-opt-out";
export const OPT_OUT_DAYS = 30;
export const CLOSE_COOLDOWN_MS = 10 * 60 * 1000;
export const IDLE_MS = 30000;

export const UTM_PARAMS = {
  utm_source: "bids",
  utm_medium: "popup",
  utm_campaign: "bidding_suggestions",
};

export const buildQuickViewPath = (pathname, handle, bidAuctionId) => {
  const basePath = pathname.replace(/\/quick-view\/.*$/, "");
  const auctionQuery = bidAuctionId ? `auction_id=${bidAuctionId}` : "";

  if (basePath === "/") {
    return auctionQuery
      ? `/quick-view/${handle}?${auctionQuery}`
      : `/quick-view/${handle}`;
  }

  return auctionQuery
    ? `${basePath}/quick-view/${handle}?${auctionQuery}`
    : `${basePath}/quick-view/${handle}`;
};

export const buildSuggestionUrl = (quickViewPath, shopifyProductId) => {
  const [path, existingQuery] = quickViewPath.split("?");
  const params = new URLSearchParams(existingQuery || "");

  Object.entries(UTM_PARAMS).forEach(([key, value]) => {
    params.set(key, value);
  });
  params.set("utm_content", `product_${shopifyProductId}`);

  return `${path}?${params.toString()}`;
};

export const isOptedOut = () => {
  const optedOutUntil = localStorage.getItem(OPT_OUT_KEY);
  if (!optedOutUntil) {
    return false;
  }
  return Date.now() < Number(optedOutUntil);
};

export const isWithinCloseCooldown = () => {
  const dismissedAt = localStorage.getItem(DISMISSED_AT_KEY);
  if (!dismissedAt) {
    return false;
  }
  return Date.now() - Number(dismissedAt) < CLOSE_COOLDOWN_MS;
};

export const markModalDismissed = () => {
  localStorage.setItem(DISMISSED_AT_KEY, String(Date.now()));
};

export const setOptOut = () => {
  const expiresAt = Date.now() + OPT_OUT_DAYS * 24 * 60 * 60 * 1000;
  localStorage.setItem(OPT_OUT_KEY, String(expiresAt));
};

export const suggestionToProduct = (suggestion) => ({
  shopify_product_id: suggestion.shopify_product_id,
  bidAuctionId: suggestion.bid_auction_id,
  handle: suggestion.handle,
  current_bid: Math.round(suggestion.current_bid * 100),
  bids_count: suggestion.bids_count || 0,
  tags: suggestion.tags || [],
  vendor: suggestion.vendor,
  end_at: suggestion.end_at,
});

export const productToSuggestionUpdates = (product) => ({
  current_bid: product.current_bid / 100,
  bids_count: product.bids_count,
  end_at: product.end_at,
});
